import { Download, Smartphone } from "lucide-react";
import { Button, buttonVariants } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { downloadPersonVCard } from "@/lib/vcard";

interface PersonContactDownloadButtonProps {
  firstName: string;
  lastName: string;
  email?: string | null;
  phone?: string | null;
  companyName?: string | null;
  variant?: "default" | "outline" | "ghost" | "link";
  size?: "default" | "sm" | "lg";
  className?: string;
  label?: string;
  iconOnly?: boolean;
}

export function PersonContactDownloadButton({
  firstName,
  lastName,
  email,
  phone,
  companyName,
  variant = "outline",
  size = "sm",
  className,
  label = "Add to phone",
  iconOnly = false,
}: PersonContactDownloadButtonProps) {
  if (!email && !phone) {
    return null;
  }

  const icon = iconOnly ? (
    <Download className="h-3.5 w-3.5" />
  ) : (
    <Smartphone className="h-3.5 w-3.5" />
  );

  if (variant === "link") {
    return (
      <button
        type="button"
        className={cn(
          buttonVariants({ variant: "link", size }),
          "h-auto px-0 py-0",
          className,
        )}
        onClick={(event) => {
          event.stopPropagation();
          downloadPersonVCard({
            firstName,
            lastName,
            email,
            phone,
            companyName,
          });
        }}
      >
        {icon}
        {!iconOnly && label}
      </button>
    );
  }

  return (
    <Button
      type="button"
      variant={variant}
      size={size}
      className={className}
      onClick={(event) => {
        event.stopPropagation();
        downloadPersonVCard({
          firstName,
          lastName,
          email,
          phone,
          companyName,
        });
      }}
    >
      {icon}
      {!iconOnly && label}
    </Button>
  );
}
